require('/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/facebook/facebook.module.scss.module.css');

export const facebookBrandInput = "_facebook-brand-input_1v3iw_1";
export const facebookBrandValid = "_facebook-brand-valid_1v3iw_1";
export const smallViewportSupport = "_small-viewport-support_1v3iw_1";
export const facebookBrandError = "_facebook-brand-error_1v3iw_1";
export const facebookBrandRow = "_facebook-brand-row_1v3iw_1";
export const facebookBrandText = "_facebook-brand-text_1v3iw_1";
export const facebookBrandCheckbox = "_facebook-brand-checkbox_1v3iw_1";
